import { render, staticRenderFns } from "./image.vue?vue&type=template&id=168bf1f2&scoped=true"
import script from "./image.vue?vue&type=script&lang=ts"
export * from "./image.vue?vue&type=script&lang=ts"
import style0 from "./image.vue?vue&type=style&index=0&id=168bf1f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168bf1f2",
  null
  
)

export default component.exports